import { makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';

const useStyles = makeStyles({
  root: {
    borderColor: '#e3e3e3',
    borderTopStyle: 'solid',
    marginBlockStart: 0,
    marginBlockEnd: 8,
  },
});

const Hr: FC = () => {
  const styles = useStyles();

  return <hr className={styles.root} />;
};

export default Hr;
